import { ViewModel,View, ObservableArray } from "binder"
import  { ReceiptFormForCodeConversionView } from "./receiptFormForCodeConversion-view"
import { InternalTransferListViewModel, TransferType } from "../internalTransferList/internalTransferList-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ReceiptFormForCodeConversionViewModel extends ViewModel{
    constructor(parentViewModel: InternalTransferListViewModel, id: string) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.transferId = id;
        this.load();

        this.destinationLineItems = ObservableArray.create<LineItem>();
    }
    closePopup(resultCode?: string) {
        this._typedParent.isShowingPopup = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new ReceiptFormForCodeConversionView();
    }
    public getTypeId(): string {
        return "VM-202cdfda-a7f2-4f03-b1e7-be2ebeb7125e"
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set transferId(v: string) { this._transferId = v; } public get transferId(): string { return this._transferId;} private _transferId: string;
    public set transferType(v: string) { this._transferType = v; } public get transferType(): string { return this._transferType;} private _transferType: string;
    public set destinationLineItems(v: ObservableArray<LineItem>) { this._destinationLineItems = v; } public get destinationLineItems(): ObservableArray<LineItem> { return this._destinationLineItems;} private _destinationLineItems: ObservableArray<LineItem>;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    private _typedParent : InternalTransferListViewModel;

    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/GetInternalTransferInfo',{
                Id:this.transferId,
            });
            this.transferType = result.TransferType;
            this.toWarehouseId = result.ToWarehouseId;
            this.toWarehouseName = result.ToWarehouseName;
            this.destinationLineItems.update(...result.ReceiptProducts.map((q,i)=>{
                let r = new LineItem(this);
                r.index = i+1;
                r.productCarModel = q.ProductCarModel;
                r.productCode = q.ProductCode;
                r.productName = q.ProductName;
                r.productUnit = q.UnitName;
                r.amount = q.Amount;
                r.measuredProductId = q.MeasuredProductId;
                r.showFeePrice = this.transferType == TransferType.CodeConversion.toString();
                return r;
            }));
            this.updateReceiptFeePrice();

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async updateReceiptFeePrice(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetLastWarehouseReceiptBillMeanPrice',{
                WarehouseId: this.toWarehouseId,
                MeasuredProductIds: this.destinationLineItems.map(q => { return q.measuredProductId})
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            result.MeanPrices.map(p=>{
                let product = this.destinationLineItems.filter(q => q.measuredProductId == p.MeasuredProductId)[0];
                product.feePrice = p.MeanPrice;
            });
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async receipt() {
        try {
            let confirmation = '';
            confirmation = await this.messageBoxWarningYesNo('آیا این سطر رسید شود؟', 'درخواست رسید');
            if (confirmation == 'no') {
                return;
            }
            this._typedParent.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/CreateReceiptForInternalTransfer', {
                TransferType: this.transferType,
                InternalTransfer: this.transferId,
                FeePrices: this.destinationLineItems.map(q => { return {
                    MeasuredProductId: q.measuredProductId,
                    FeePrice: q.feePrice
                }})
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('رسید با موفقیت ثبت شد.', 'عملیات موفق');
            this._typedParent.refresh();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'خطا');
        } finally {
            this._typedParent.isLoading = false;
            this.closePopup();
        }
    }

}

export class LineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ReceiptFormForCodeConversionViewModel) {
        super(parent);
        this._typedParent = parent;   
    }
    private _typedParent:ReceiptFormForCodeConversionViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productUnit(v: string) { this._productUnit = v; } public get productUnit(): string { return this._productUnit;} private _productUnit: string;
    public set amount(v: number) { this._amount =v; } public get amount(): number { return this._amount;} private _amount: number;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice;} private _feePrice: number;
    public set showFeePrice(v: boolean) { this._showFeePrice = v; } public get showFeePrice(): boolean { return this._showFeePrice;} private _showFeePrice: boolean;
    
}
